import { render, staticRenderFns } from "./BookingPayment.vue?vue&type=template&id=48470a0d&scoped=true"
import script from "./BookingPayment.vue?vue&type=script&lang=js"
export * from "./BookingPayment.vue?vue&type=script&lang=js"
import style0 from "./BookingPayment.vue?vue&type=style&index=0&id=48470a0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48470a0d",
  null
  
)

export default component.exports